<template>
    <b-form-select v-if="bankAccountList.length" v-model="selectedBankAccount" @change="onOptionSelected">
        <b-form-select-option v-for="bankAccount in bankAccountList" :value="bankAccount.id" :key="bankAccount.id">
            {{bankAccount.iban}}
        </b-form-select-option>
    </b-form-select>
</template>

<script>
export default {
    name: "BankSelector",
    props: {
        bankAccountList: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        bankAccountList() {
            if (!this.selectedBankAccount) {
                if (this.bankAccountList.length)
                    this.selectedBankAccount = this.bankAccountList[0].id
                else
                    this.selectedBankAccount = null
            }
        }
    },
    data() {
        return {
            selectedBankAccount: null
        }
    },
    methods: {
        onOptionSelected() {
            this.$emit('bankAccountSelected', this.bankAccountList.find((x) => x.id === this.selectedBankAccount))
        }
    }
}
</script>